import types from '../../constants';

const initialState = {
  selected: '',
};

const ExerciseWaitingReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.EXERCISE_WAITING_SELECT:
      return {
        ...state,
        selected: action.payload,
      };
    default:
      return state;
  }
};

export default ExerciseWaitingReducers;
